module.exports = __webpack_public_path__ + "img/100.עברית.42d4bfc5.svg";